import { Comment } from '@sketchnote/slate-plugins/src/comments/useComments';
import { TElement } from '@udecode/plate';
import { API } from 'src/api';

export const useDocComments = () => {
  const getCommentById = async ({ id }: { id: string }) => {
    try {
      const response = await API.get(`/creation/comment?id=${id}`);
      if (response.data?.success && response.data.data) {
        return formatComment(response.data.data);
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const createCommentThread = async ({
    content,
    tags,
    text,
    creationId,
  }: {
    content: TElement[];
    tags: string[];
    text: string;
    creationId: string;
  }) => {
    try {
      const response = await API.post('/creation/comment', { content, tags, text, creationId });
      return (response.data?.data?.comment as string) || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const addCommentResponse = async ({
    commentId,
    content,
    tags,
    text,
  }: {
    commentId: string;
    content: TElement[];
    tags: string[];
    text: string;
  }) => {
    try {
      const response = await API.post('/creation/comment', {
        comment: commentId,
        content,
        tags,
        text,
      });
      return response.data.data.id;
    } catch (error) {
      console.error(error);
    }
  };

  const deleteCommentThread = async ({ id }: { id: string }) => {
    try {
      const response = await API.delete(`/creation/comment?id=${id}`);

      if (response.data.success) {
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };
  return {
    getCommentById,
    createCommentThread,
    addCommentResponse,
    deleteCommentThread,
  };
};

function formatComment(data): Comment {
  return {
    content: data.content,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    id: data._id,
    owner: {
      avatar: data?.member?.avatar,
      email: data?.member?.email,
      firstname: data?.member?.firstname,
      id: data?.member?.memberId,
      lastname: data?.member?.lastname,
    },
    replies: data.responses.map((response) => ({
      content: response.content,
      createdAt: response.createdAt,
      updatedAt: response.updatedAt,
      id: response._id,
      owner: {
        avatar: response?.member?.avatar,
        email: response?.member?.email,
        firstname: response?.member?.firstname,
        id: response?.member?.memberId,
        lastname: response?.member?.lastname,
      },
    })),
  };
}
